import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';


const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'buttonVariant',
})(({ buttonVariant }) => ({
  height: '44px',
  padding: '0 24px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  ...(buttonVariant === 'cancel' && {
    minWidth: '100px',
    backgroundColor: '#e5e5e5',
    color: '#262626',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#d5d5d5',
    },
  }),
  ...(buttonVariant === 'submit' && {
    minWidth: '140px',
    backgroundColor: '#4AB3BC',
    color: '#fff',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#4AB3BC',
    },
    '&:disabled': {
      backgroundColor: '#ccc',
      color: '#999',
    },
  }),
  ...(buttonVariant === 'delete' && {
    minWidth: '100px',
    backgroundColor: '#ef0c23',
    color: '#fff',
    border: '1px solid #ef0c23',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#ef0c23',
      color: '#fff',
      borderColor: '#ef0c23',
    },
  }),
  // 다크(#333) 액션 — "수정완료" 등 수정 확정 버튼.
  ...(buttonVariant === 'dark' && {
    minWidth: '140px',
    backgroundColor: '#333',
    color: '#fff',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#333',
    },
  }),
}));

const CommonModalButton = ({ variant = 'submit', children, ...rest }) => (
  <StyledButton buttonVariant={variant} {...rest}>
    {children}
  </StyledButton>
);

export default CommonModalButton;
